import api from '../api'
import keymap from './keymap.js'

let context = null

let queue = [] 

let currenntShortcuts = []

let handleKeyDown = (e) => {
    if (e.repeat) return
    queue.push(keymap[e.keyCode])
    checkForAction()
}
let handleKeyUp = (e) => {
    queue = queue.filter(el => el !== keymap[e.keyCode]);
}

let filterForUnique = function(itm, i, a) {
    return i == a.indexOf(itm);
}

let fetchShortcuts = async () => {
    try {
        let res = await api.getAccessibility()
        for (const sh of res.data.res) {
            if (sh.acc_keys == '') continue // ignore empty binds
            let obj = {
                keys: [],
                action: sh.acc_action, // used for other types of navigation
                type: sh.acc_type,
                data: null,
                display: sh.acc_text
            }
            // sets data for action
            let d = sh.path
            if (sh.acc_action === 'Agenda') d = '/agenda'
            if (sh.acc_action === 'Networking') d = '/list-of-attendees'
            obj.data = d  // if type == "visual" this is where the link is
            
            if (sh.acc_mod) {
                if (sh.acc_mod.includes('ctrl')) obj.keys.push('CONTROL')
                if (sh.acc_mod.includes('shift')) obj.keys.push('SHIFT')
                if (sh.acc_mod.includes('alt')) obj.keys.push('ALT')
            }

            let arr = sh.acc_keys.split('')
            arr = arr.filter(filterForUnique)
            obj.keys =[...obj.keys, ...arr]

            currenntShortcuts.push(obj)
        }
    } catch (error) {
        console.warn(error);
        setTimeout(() => {
            fetchShortcuts()
        }, 1000);
    }
}

let checkForAction = () => {
    for (const sh of currenntShortcuts) {
        if (isSubset(queue, sh.keys)) {
            executeAction(sh)
            return
        }
    }
}

let executeAction = (shortcut) => {
    switch (shortcut.type) {
        case 'visual':
            context.setAction(shortcut)
            break;
    
        default:
            break;
    }
}

let isSubset = ( arr1, arr2 ) => {
    for (let i = 0; i < arr2.length; i++) {
        if ( arr1.indexOf( arr2[i] ) == -1 ) {
          return false;
        }
    }
    return true;
}

let init = (ctx, debug) => {
    context = ctx;
    fetchShortcuts()
    // TODO dodati handler za alt-tab da restart queue after merge with permissions 
    document.addEventListener('keydown', handleKeyDown, false)
    document.addEventListener('keyup', handleKeyUp, false)
    if (debug)
        setInterval(() => {
            console.log(queue);
        }, 3000);
}

export default {
    init,
};
